import { useState, useMemo } from 'react';
import AccessoryFilterPanel from '../components/AccessoryFilterPanel';
import AccessoryProductGrid from '../components/AccessoryProductGrid';
import { accessories } from '../data/accessories';

export default function Accessories() {
    const [sortBy, setSortBy] = useState('best-selling');
    const [showMobileFilters, setShowMobileFilters] = useState(false);
    const [viewMode, setViewMode] = useState('grid');
    const [filters, setFilters] = useState({
        types: [], brands: [], priceRange: [0, 50000],
        compatibility: [], connectivity: [], powerOutput: [],
        availability: false, discount: false, rating: 0
    });

    const filteredProducts = useMemo(() => {
        let filtered = [...accessories];
        if (filters.types.length > 0) filtered = filtered.filter(p => filters.types.includes(p.type));
        if (filters.brands.length > 0) filtered = filtered.filter(p => filters.brands.includes(p.brand));
        if (filters.priceRange[0] > 0 || filters.priceRange[1] < 50000)
            filtered = filtered.filter(p => p.price >= filters.priceRange[0] && p.price <= filters.priceRange[1]);
        if (filters.compatibility.length > 0) filtered = filtered.filter(p => filters.compatibility.includes(p.compatibility));
        if (filters.connectivity.length > 0) filtered = filtered.filter(p => filters.connectivity.includes(p.connectivity));
        if (filters.powerOutput.length > 0) filtered = filtered.filter(p => filters.powerOutput.includes(p.powerOutput));
        if (filters.availability) filtered = filtered.filter(p => p.stock > 0);
        if (filters.discount) filtered = filtered.filter(p => p.discount > 0);
        if (filters.rating > 0) filtered = filtered.filter(p => p.rating >= filters.rating);
        switch (sortBy) {
            case 'price-low': filtered.sort((a, b) => a.price - b.price); break;
            case 'price-high': filtered.sort((a, b) => b.price - a.price); break;
            case 'newest': filtered.sort((a, b) => new Date(b.releaseDate).getTime() - new Date(a.releaseDate).getTime()); break;
            case 'best-selling': filtered.sort((a, b) => b.sales - a.sales); break;
        }
        return filtered;
    }, [filters, sortBy]);

    return (
        <div className="min-h-screen bg-card pt-[10px]">
            <div className="max-w-[1400px] mx-auto px-4 py-6">
                <nav className="flex items-center gap-2 text-sm mb-6">
                    <a href="/" className="text-muted-foreground hover:text-[#FF6B35] transition-colors">Home</a>
                    <i className="ri-arrow-right-s-line text-muted-foreground/60"></i>
                    <span className="text-foreground font-medium">Accessories</span>
                </nav>
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
                    <div>
                        <h1 className="text-3xl font-bold text-foreground mb-2">Accessories</h1>
                        <p className="text-muted-foreground">{filteredProducts.length} products found</p>
                    </div>
                    <div className="flex items-center gap-3 flex-wrap">
                        <div className="flex items-center gap-2 bg-muted rounded-lg p-1">
                            <button onClick={() => setViewMode('grid')} className={`w-9 h-9 flex items-center justify-center rounded-md transition-colors ${viewMode === 'grid' ? 'bg-card text-[#FF6B35] shadow-sm' : 'text-muted-foreground hover:text-foreground'}`}>
                                <i className="ri-grid-line text-lg"></i>
                            </button>
                            <button onClick={() => setViewMode('list')} className={`w-9 h-9 flex items-center justify-center rounded-md transition-colors ${viewMode === 'list' ? 'bg-card text-[#FF6B35] shadow-sm' : 'text-muted-foreground hover:text-foreground'}`}>
                                <i className="ri-list-check text-lg"></i>
                            </button>
                        </div>
                        <select value={sortBy} onChange={(e) => setSortBy(e.target.value)} className="px-4 py-2 border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#FF6B35] cursor-pointer">
                            <option value="best-selling">Best Selling</option>
                            <option value="price-low">Price: Low to High</option>
                            <option value="price-high">Price: High to Low</option>
                            <option value="newest">Newest</option>
                        </select>
                        <button onClick={() => setShowMobileFilters(true)} className="lg:hidden px-4 py-2 bg-foreground text-white rounded-lg text-sm font-medium hover:bg-foreground/90 transition-colors flex items-center gap-2 whitespace-nowrap">
                            <i className="ri-filter-3-line"></i> Filters
                        </button>
                    </div>
                </div>
                <div className="flex gap-6">
                    <div className="hidden lg:block w-64 flex-shrink-0">
                        <AccessoryFilterPanel filters={filters} setFilters={setFilters} />
                    </div>
                    <div className="flex-1"><AccessoryProductGrid products={filteredProducts} /></div>
                </div>
            </div>
            {showMobileFilters && (
                <div className="fixed inset-0 z-50 lg:hidden">
                    <div className="absolute inset-0 bg-black/50" onClick={() => setShowMobileFilters(false)}></div>
                    <div className="absolute right-0 top-0 bottom-0 w-full max-w-sm bg-card shadow-xl overflow-y-auto">
                        <div className="sticky top-0 bg-card border-b border-border px-4 py-4 flex items-center justify-between z-10">
                            <h2 className="text-lg font-bold text-foreground">Filters</h2>
                            <button onClick={() => setShowMobileFilters(false)} className="w-8 h-8 flex items-center justify-center text-muted-foreground hover:text-foreground"><i className="ri-close-line text-xl"></i></button>
                        </div>
                        <div className="p-4"><AccessoryFilterPanel filters={filters} setFilters={setFilters} /></div>
                        <div className="sticky bottom-0 bg-card border-t border-border p-4">
                            <button onClick={() => setShowMobileFilters(false)} className="w-full py-3 bg-[#FF6B35] text-white rounded-lg font-medium hover:bg-[#E55A2B] transition-colors whitespace-nowrap">Apply Filters</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
